import { InlineText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { IRegion } from '../../../../types/geoSwitcher';

import * as styles from './GeoSuggest.css';

export interface IGeoSuggestProps {
  id: string;
  labelledBy: string;
  activeIndex: number;
  suggests: IRegion[];
  onSelect(region: IRegion): void;
}

export function GeoSuggest({ id, labelledBy, activeIndex, suggests, onSelect }: IGeoSuggestProps) {
  const activeOptionRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    activeOptionRef.current?.scrollIntoView({ block: 'nearest' });
  }, [activeIndex]);

  return (
    <div
      id={id}
      role="listbox"
      aria-labelledby={labelledBy}
      className={styles['suggests']}
      onMouseDown={event => event.preventDefault()}
    >
      {suggests.map((region, index) => {
        return (
          <div
            key={region.id}
            id={`${id}-${index}`}
            role="option"
            aria-selected={index === activeIndex}
            ref={index === activeIndex ? activeOptionRef : undefined}
            className={styles['suggest']}
            onClick={() => onSelect(region)}
          >
            <InlineText2>{region.displayName}</InlineText2>
          </div>
        );
      })}
    </div>
  );
}
